import { SidebarItemVM } from 'src/app/components/layout/sidebar/_types/SidebarItemVM';

export const getSidebarItems = (): SidebarItemVM[] => [
  {
    path: `/portal/dashboard`,
    title: 'Dashboard',
    type: 'link',
    iconFilePath: 'assets/icons/icon-nav-dash.svg',
  },
];
